import React from "react";
import "./CustomLabel.css";

interface LabelProps {
  text: string;
}

const CustomLabel: React.FC<LabelProps> = ({ text }) => {
  return (
    <span className="custom-label-container">
      {text}
    </span>
  );
};

export default CustomLabel;